import { iIconProps } from '../icon';

export default function CloseIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 24 24' {...props}>
            <path
                fillRule='evenodd'
                d='M5.12 5.12a1.25 1.25 0 0 1 1.77 0l5.12 5.12 5.12-5.12a1.25 1.25 0 0 1 1.77 0c.49.49.49 1.28 0 1.77l-5.12 5.12 5.12 5.12c.49.49.49 1.28 0 1.77s-1.28.49-1.77 0l-5.12-5.12-5.12 5.12c-.49.49-1.28.49-1.77 0a1.25 1.25 0 0 1 0-1.77l5.12-5.12-5.12-5.12a1.25 1.25 0 0 1 0-1.77'
                fill='currentColor'
            />
        </svg>
    );
}
